import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

import {
  FaMapMarkerAlt,
  FaEnvelope,
  FaFacebookF,
  FaLinkedinIn,
  FaInstagram,
  FaTwitter,
} from "react-icons/fa";

export default function Footer() {
  return (
    <footer className="footer-section">
      <div className="footer-container">

        {/* ABOUT US */}
        <div className="footer-column footer-about">
          <h3>ABOUT US</h3>
          <p>
            Intelbuild Engineering Services LLP is a multidisciplinary engineering consultancy delivering Architecture, Structural Engineering, BIM, and Project Management solutions. 
            We design safe, sustainable, and high-performance infrastructure for residential, commercial, industrial, and oil & gas sectors.
          </p>

          <div className="footer-info">
            <FaMapMarkerAlt className="footer-icon" />
            <span>
              304 Stanford Plaza, Off Link Road, Andheri (W),
              Mumbai-400058, India
            </span>
          </div>

          <div className="footer-info">
            <FaEnvelope className="footer-icon" />
            <a href="mailto:info@intelbuild.in">
              info@intelbuild.in
            </a>
          </div>

          {/* SOCIAL ICONS */}
          <div className="social-icons">
            <a
              href="https://www.facebook.com/intelbuildhuzaifa"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
            >
              <FaFacebookF />
            </a>

            <a
              href="https://www.linkedin.com/company/intelbuild-engineering-services-llp/?originalSubdomain=in"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
            >
              <FaLinkedinIn />
            </a>

            <a
              href="https://www.instagram.com/intelbuildhuzaifa"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
            >
              <FaInstagram />
            </a>

            <a
              href="https://www.twitter.com/intelbuildarc"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Twitter"
            >
              <FaTwitter />
            </a>
          </div>
        </div>

        {/* QUICK LINKS */}
        <div className="footer-column">
          <h3>QUICK LINKS</h3>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/projects">Projects</Link></li>
            <li><Link to="/contact">Contact Us</Link></li>
          </ul>
        </div>

        {/* SERVICES */}
        <div className="footer-column">
          <h3>SERVICES</h3>
          <ul>
            <li><Link to="/services/oil-gas">Oil & Gas</Link></li>
            <li>
              <Link to="/services/pre-engineered-buildings">
                Pre-Engineered Buildings
              </Link>
            </li>
            <li><Link to="/services/real-estate">Real Estate</Link></li>
            <li><Link to="/services/bim-services">BIM Services</Link></li>
            <li>
              <Link to="/services/sustainable-design">
                Sustainable Design & Engineering
              </Link>
            </li>
            <li>
              <Link to="/services/structural-audit">
                Structural Audit
              </Link>
            </li>
          </ul>
        </div>

        {/* RESOURCES */}
        <div className="footer-column">
          <h3>RESOURCES</h3>
          <ul>
            <li><Link to="/careers">Careers</Link></li>
          </ul>
        </div>
      </div>

      {/* COPYRIGHT */}
      <div className="footer-bottom">
  © 2026 INTELBUILD. Designed and Developed by{" "}
  <a
    href="https://livasys.com/"
    target="_blank"
    rel="noopener noreferrer"
    className="footer-link"
  >
    Livasys IT Solutions
  </a>
</div>
    </footer>
  );
}
